import React, { useContext } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import { useHistory } from 'react-router-dom';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeDishPositionContext,
	IChangeDishPositionContext,
} from '../../../../changeDishPositionState/changeDishPositionContext';
import { updateDishPositions } from 'backend/dishes';
import Text from 'components/Text/Text';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		typeOfModalWindow,
		positionsData,
		IDSelectedRestaurant,
		IDSelectedCategory,
		IDSelectedSubCategory,
		selectedAdditionalRestaurants,
		fetchedRestaurants,
	} = useContext<IChangeDishPositionContext>(ChangeDishPositionContext);
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const history = useHistory();
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const restaurantsToApplyChanges = IDSelectedRestaurant
		? fetchedRestaurants.filter((el) => [IDSelectedRestaurant, ...selectedAdditionalRestaurants].includes(el.id))
		: [];

	const handleRedirect = () => {
		history.push('/menu/dishes');
	};

	const handleConfirm = async () => {
		if (positionsData && IDSelectedRestaurant && IDSelectedCategory && IDSelectedSubCategory) {
			try {
				const restaurantIds = [IDSelectedRestaurant, ...selectedAdditionalRestaurants];
				const restaurantChains = restaurantIds.map((el) => ({
					restaurantId: el,
					categoryId: IDSelectedCategory,
					subCategoryId: IDSelectedSubCategory,
				}));
				const dishIds = positionsData.map((el) => el.id);
				showLoader();
				await updateDishPositions({
					restaurantChains,
					dishIds,
				});
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={handleRedirect}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleConfirm}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmSave'}
				description="saveChangeOnRestaurants"
				typeOfInfoIcon="withoutIcon"
				additionalContent={
					!!restaurantsToApplyChanges?.length && (
						<div className={style.itemsList}>
							{restaurantsToApplyChanges.map((el) => (
								<Text
									key={el.id}
									translationKey={el.name}
									theme="secondaryLight"
									size="l"
									weight="bold"
								/>
							))}
						</div>
					)
				}
			/>
			<ModalSentSuccessfully
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</div>
	);
};

export default ModalWindows;
